module.exports = __webpack_public_path__ + "img/copy.77dd4acc.svg";